import { z } from "zod";

/**
 * CRM sync schemas for the people payload, extracted from `get-people.ts` so it stays under
 * the size ratchet; re-exported from there for backward-compatible imports.
 */
export const CrmOrganizationSchema = z
	.object({
		id: z.number().nullable(),
		crmType: z.string().nullable().optional(),
		lastUpdatedAt: z.string().nullable(),
		accountOwner: z.string().nullable(),
		accountOwnerId: z.number().nullable(),
		url: z.string().nullable(),
		referenceId: z.string().nullable(),
		customField1: z.string().nullable(),
		customField2: z.string().nullable(),
		syncStatus: z.string().nullable().optional(),
		syncError: z.string().nullable().optional(),
	})
	.passthrough();

export const CrmDealSchema = z
	.object({
		id: z.number().nullable(),
		crmType: z.string().nullable().optional(),
		dealName: z.string().nullable(),
		pipeline: z.string().nullable(),
		dealStage: z.string().nullable(),
		lastUpdatedAt: z.string().nullable(),
		dealOwner: z.string().nullable(),
		dealOwnerId: z.string().nullable(),
		closeDate: z.string().nullable(),
		url: z.string().nullable(),
		referenceId: z.string().nullable(),
		createdAt: z.string().nullable(),
		updatedAt: z.string().nullable(),
		companyId: z.number().nullable(),
		syncStatus: z.string().nullable().optional(),
		syncError: z.string().nullable().optional(),
		hubspotSyncStatus: z.string().nullable(),
		hubspotSyncError: z.string().nullable(),
	})
	.passthrough();

export const CrmLeadSchema = z
	.object({
		id: z.number().nullable().optional(),
		prospectId: z.number().nullable().optional(),
		companyId: z.number().nullable().optional(),
		crmType: z.string().nullable().optional(),
		referenceId: z.string().nullable().optional(),
		url: z.string().nullable().optional(),
		leadName: z.string().nullable().optional(),
		leadStage: z.string().nullable().optional(),
		pipeline: z.string().nullable().optional(),
		leadOwner: z.string().nullable().optional(),
		leadOwnerId: z.string().nullable().optional(),
		syncStatus: z.string().nullable().optional(),
		syncError: z.string().nullable().optional(),
		lastUpdatedAt: z.string().nullable().optional(),
	})
	.passthrough();

export const CrmProspectSchema = z
	.object({
		id: z.number().nullable(),
		crmType: z.string().nullable().optional(),
		currentStatus: z.string().nullable(),
		lastUpdatedAt: z.string().nullable(),
		accountOwner: z.string().nullable(),
		accountOwnerId: z.number().nullable(),
		url: z.string().nullable(),
		referenceId: z.string().nullable(),
		customField1: z.string().nullable(),
		customField2: z.string().nullable(),
		syncStatus: z.string().nullable().optional(),
		syncError: z.string().nullable().optional(),
	})
	.passthrough();
